import { Facade, vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.support.'

@vsingleton()
export class AdminTicketRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'tickets.'

  index() {
    return this.ziggyRoute('index')
  }

  show(id) {
    return this.ziggyRoute('show', id)
  }

  store() {
    return this.ziggyRoute('store')
  }

  update(id) {
    return this.ziggyRoute('update', id)
  }

  exportExcel() {
    return this.ziggyRoute('export')
  }

}

export class AdminTicketRouteFacade extends Facade<AdminTicketRoute>() {
  static getFacadeAccessor() {
    return AdminTicketRoute
  }
}